import React, { useState } from 'react';
import axios from 'axios';

function TrainingControl() {
  const [algorithm, setAlgorithm] = useState('SPTnet');
  const [param1, setParam1] = useState('');
  const [param2, setParam2] = useState('');
  const [param3, setParam3] = useState('');
  const [param4, setParam4] = useState('');
  const [sim1, setSim1] = useState('');
  const [sim2, setSim2] = useState('');
  const [sim3, setSim3] = useState('');
  const [sim4, setSim4] = useState('');
  const [predictParam, setPredictParam] = useState('');
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  const handleTrain = async () => {
    try {
      await axios.post('/start-training/', {
        algorithm,
        param1,
        param2,
        param3,
        param4,
      });
      setMessage('训练已启动');
    } catch (error) {
      setMessage('训练启动失败');
    }
  };

  const handleSimulate = async () => {
    try {
      await axios.post('/simulate/', {
        sim1,
        sim2,
        sim3,
        sim4,
      });
      setMessage('模拟数据生成成功');
    } catch (error) {
      setMessage('模拟生成失败');
    }
  };

  const handlePredict = async () => {
    try {
      await axios.post('/start-predict/', {
        algorithm,
        predictParam,
      });
      setMessage('推理已启动');
    } catch (error) {
      setMessage('推理失败');
    }
  };

  const handleUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      await axios.post('/upload/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage('上传成功');
    } catch (error) {
      setMessage('上传失败');
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: '600px', padding: '40px', border: '1px solid #ddd', borderRadius: '12px', backgroundColor: '#f9f9f9' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '28px', fontSize: '24px' }}>训练控制面板</h2>

        <label style={{ fontWeight: 'bold' }}>模拟数据参数：</label>
        <input type="text" placeholder="模拟参数1" value={sim1} onChange={(e) => setSim1(e.target.value)} style={{ width: '100%', marginBottom: '10px', padding: '8px' }} />
        <input type="text" placeholder="模拟参数2" value={sim2} onChange={(e) => setSim2(e.target.value)} style={{ width: '100%', marginBottom: '10px', padding: '8px' }} />
        <input type="text" placeholder="模拟参数3" value={sim3} onChange={(e) => setSim3(e.target.value)} style={{ width: '100%', marginBottom: '10px', padding: '8px' }} />
        <input type="text" placeholder="模拟参数4" value={sim4} onChange={(e) => setSim4(e.target.value)} style={{ width: '100%', marginBottom: '20px', padding: '8px' }} />
        <button onClick={handleSimulate} style={{ width: '100%', background: '#2b6cb0', color: 'white', padding: '12px', marginBottom: '28px', borderRadius: '6px' }}>
          生成模拟数据
        </button>

        <label style={{ fontWeight: 'bold' }}>选择算法：</label>
        <select value={algorithm} onChange={(e) => setAlgorithm(e.target.value)} style={{ width: '100%', marginBottom: '16px', padding: '8px' }}>
          <option value="SPTnet">SPTnet</option>
          <option value="BNP-Track">BNP-Track</option>
          <option value="TrackMate">TrackMate</option>
          <option value="DeepTrack">DeepTrack</option>
        </select>

        <label style={{ fontWeight: 'bold' }}>训练参数：</label>
        <input type="text" placeholder="batch size" value={param1} onChange={(e) => setParam1(e.target.value)} style={{ width: '100%', marginBottom: '10px', padding: '8px' }} />
        <input type="text" placeholder="learning rate" value={param2} onChange={(e) => setParam2(e.target.value)} style={{ width: '100%', marginBottom: '10px', padding: '8px' }} />
        <input type="text" placeholder="参数3" value={param3} onChange={(e) => setParam3(e.target.value)} style={{ width: '100%', marginBottom: '10px', padding: '8px' }} />
        <input type="text" placeholder="参数4" value={param4} onChange={(e) => setParam4(e.target.value)} style={{ width: '100%', marginBottom: '20px', padding: '8px' }} />
        <button onClick={handleTrain} style={{ width: '100%', background: '#2b6cb0', color: 'white', padding: '12px', marginBottom: '28px', borderRadius: '6px' }}>
          启动训练
        </button>

        <label style={{ fontWeight: 'bold' }}>推理参数：</label>
        <input type="text" placeholder="如：--video input.avi" value={predictParam} onChange={(e) => setPredictParam(e.target.value)} style={{ width: '100%', marginBottom: '20px', padding: '8px' }} />
        <input type="text" placeholder="参数2" value={predictParam} onChange={(e) => setPredictParam(e.target.value)} style={{ width: '100%', marginBottom: '20px', padding: '8px' }} />
        <input type="text" placeholder="如：--video input3.avi" value={predictParam} onChange={(e) => setPredictParam(e.target.value)} style={{ width: '100%', marginBottom: '20px', padding: '8px' }} />
        <input type="text" placeholder="如：--video input4.avi" value={predictParam} onChange={(e) => setPredictParam(e.target.value)} style={{ width: '100%', marginBottom: '20px', padding: '8px' }} />
        <button onClick={handlePredict} style={{ width: '100%', background: '#2b6cb0', color: 'white', padding: '12px', marginBottom: '28px', borderRadius: '6px' }}>
          执行推理
        </button>

        <label style={{ fontWeight: 'bold' }}>上传文件（如 .txt/.avi/.csv）：</label>
        <input type="file" onChange={(e) => setFile(e.target.files[0])} style={{ marginBottom: '16px' }} />
        <button onClick={handleUpload} style={{ width: '100%', background: '#2b6cb0', color: 'white', padding: '12px', marginBottom: '28px', borderRadius: '6px' }}>
          上传数据到AWS S3 bucket
        </button>

        <label style={{ fontWeight: 'bold' }}>下载数据（如 .txt/.avi/.csv）：</label>
        <input type="file" onChange={(e) => setFile(e.target.files[0])} style={{ marginBottom: '16px' }} />
        <button onClick={handleUpload} style={{ width: '100%', background: '#2b6cb0', color: 'white', padding: '12px', marginBottom: '28px', borderRadius: '6px' }}>
          从AWS S3 bucket下载数据
        </button>

        <button onClick={handleUpload} style={{ width: '100%', background: '#2b6cb0', color: 'white', padding: '12px', marginBottom: '28px', borderRadius: '6px' }}>
          进入训练过程和结果分析可视化界面
        </button>

        {message && <p style={{ textAlign: 'center', marginTop: '20px', color: '#555' }}>{message}</p>}
      </div>
    </div>
  );
}

export default TrainingControl;
